@if (maintenanceTabWarrantiesService.isLoading()) {
  <order-warranty-skeleton />
} @else if (maintenanceTabWarrantiesService.hasWarranties()) {
  <div palantir-modal-content class="resizable-content" inverted="true">
    <palantir-layout>
      <palantir-toolbar palantir-layout-header>
        <div palantir-toolbar-main class="text-sm">
          <palantir-dropdown-menu
            class="whitespace-nowrap"
            [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.FILTERS.VIEW' | translate"
            (selected)="changeWarrantyType($event)"
            [value]="maintenanceTabWarrantiesService.selectedWarrantyType()"
          >
            @for (type of warrantiesTypes; track $index) {
              <palantir-dropdown-item [value]="type.value">{{ type.label | translate }}</palantir-dropdown-item>
            }
          </palantir-dropdown-menu>
        </div>
      </palantir-toolbar>
      <div palantir-layout-content class="flex flex-col gap-4 palantir-scrollbar">
        @if (maintenanceTabWarrantiesService.selectedWarrantyType() === WARRANTY_TYPE.EQUIPMENTS) {
          @if (maintenanceTabWarrantiesService.equipments().length) {
            <div class="flex flex-col gap-4" [@listAnimation]="maintenanceTabWarrantiesService.equipments().length">
              @for (equipment of maintenanceTabWarrantiesService.equipments(); track equipment.id) {
                @if (equipment?.warranties?.length) {
                  <palantir-accordion class="warranty-accordion" [open]="true">
                    <div palantir-accordion-header>
                      <palantir-badge theme="surface">{{ equipment.warranties.length }}</palantir-badge>
                      <palantir-text type="title" class="truncate max-w-[150px]">
                        {{ equipment.number }}
                      </palantir-text>
                      <palantir-text type="description" class="truncate max-w-[150px]"> - {{ equipment.name }} </palantir-text>
                    </div>
                    @for (warranty of equipment.warranties; track warranty.id) {
                      @let warrantyForm = this.warrantiesMapperService.createForm(warranty);
                      <maintenance-warranty-card
                        [warrantyForm]="warrantyForm"
                        [isSelected]="
                          maintenanceTabWarrantiesService.selectedWarrantyForm?.get('id')?.value === warrantyForm.get('id')?.value
                        "
                        [isSingleWarranty]="equipment.warranties.length === 1"
                        (click)="
                          equipment.warranties.length > 1 && maintenanceTabWarrantiesService.selectWarranty(warrantyForm, $index)
                        "
                        matRipple
                      />
                    }
                  </palantir-accordion>
                }
              }
            </div>
          } @else {
            <div class="flex items-center justify-center h-full w-full">
              <palantir-text type="description">{{
                'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.EMPTY_STATE.DESCRIPTION' | translate
              }}</palantir-text>
            </div>
          }
        } @else {
          @if (this.maintenanceTabWarrantiesService.warrantiesForm().length) {
            <div class="flex flex-col gap-4" [@listAnimation]="this.maintenanceTabWarrantiesService.warrantiesForm().length">
              @for (warrantyForm of this.maintenanceTabWarrantiesService.warrantiesForm(); track $index) {
                <maintenance-warranty-card
                  [warrantyForm]="warrantyForm"
                  [isSelected]="maintenanceTabWarrantiesService.selectedWarrantyFormIndex() === $index"
                  [isSingleWarranty]="maintenanceTabWarrantiesService.warrantiesForm().length === 1"
                  (click)="
                    maintenanceTabWarrantiesService.warrantiesForm().length > 1 &&
                      maintenanceTabWarrantiesService.selectWarranty(warrantyForm, $index)
                  "
                  matRipple
                />
              }
            </div>
          } @else {
            <div class="flex items-center justify-center h-full w-full">
              <palantir-text type="description">{{
                'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.EMPTY_STATE.TITLE' | translate
              }}</palantir-text>
            </div>
          }
        }
      </div>
    </palantir-layout>

    <palantir-layout>
      @if (maintenanceTabWarrantiesService.selectedWarrantyForm) {
        <ng-container>
          <palantir-toolbar palantir-layout-header>
            <div palantir-toolbar-main class="text-sm">
              <span class="font-bold">{{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.DETAILS' | translate }}</span>
              •
              <span class="text-neutral-600">{{ maintenanceTabWarrantiesService.selectedWarrantyForm.get('name')?.value }}</span>
            </div>

            <palantir-toolbar-suffix>
              @if (
                hasCreateWarrantyPermission && maintenanceTabWarrantiesService.selectedWarrantyType() === WARRANTY_TYPE.MAINTENANCES
              ) {
                <palantir-button (click)="openDialog()" theme="outline" layout="prefix" icon="add-outline">
                  {{ 'TAB_WARRANTIES_MAINTENANCE.BUTTON.ADD' | translate }}</palantir-button
                >
              }
            </palantir-toolbar-suffix>
          </palantir-toolbar>

          <maintenance-warranty-detail
            id="order-warranty-detail"
            class="rounded-xl transition-scale duration-150 palantir-scrollbar"
            [warrantyForm]="maintenanceTabWarrantiesService.selectedWarrantyForm"
          />
        </ng-container>
      } @else {
        <div class="w-full h-[400px] flex flex-col items-center justify-center">
          <div class="flex flex-col items-center gap-3 mt-3">
            <palantir-icon style="font-size: 150px" name="warranty-gradient"></palantir-icon>
            <palantir-text type="title" size="lg">
              {{ 'TAB_WARRANTIES_MAINTENANCE.NO_RESULTS.TITLE' | translate }}
            </palantir-text>

            @if (maintenanceTabWarrantiesService.selectedWarrantyType() === WARRANTY_TYPE.MAINTENANCES) {
              @if (hasCreateWarrantyPermission) {
                <palantir-text type="description" size="xs">
                  {{ 'TAB_WARRANTIES_MAINTENANCE.NO_RESULTS.DESCRIPTION' | translate }}
                </palantir-text>
              } @else {
                <palantir-text type="description" size="xs">
                  {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.EMPTY_STATE.EMPTY_WARRANTIES_MAINTENANCES' | translate }}
                </palantir-text>
              }
            } @else {
              <palantir-text type="description" size="xs">
                {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.EMPTY_STATE.EMPTY_WARRANTIES_EQUIPMENTS' | translate }}
              </palantir-text>
            }
          </div>

          @if (hasCreateWarrantyPermission && maintenanceTabWarrantiesService.selectedWarrantyType() === WARRANTY_TYPE.MAINTENANCES) {
            <palantir-button (click)="openDialog()" theme="outline" layout="prefix" icon="add-outline">
              {{ 'TAB_WARRANTIES_MAINTENANCE.BUTTON.ADD' | translate }}</palantir-button
            >
          }
        </div>
      }
    </palantir-layout>
  </div>
} @else {
  <div class="w-full h-[400px] flex flex-col items-center justify-center">
    <div class="flex flex-col items-center gap-3 mt-3 mb-3">
      <palantir-icon style="font-size: 150px" name="warranty-gradient"></palantir-icon>
      <palantir-text type="title" size="lg">
        {{ 'TAB_WARRANTIES_MAINTENANCE.NO_RESULTS.TITLE' | translate }}
      </palantir-text>

      @if (hasCreateWarrantyPermission) {
        <palantir-text type="description" size="xs">
          {{ 'TAB_WARRANTIES_MAINTENANCE.NO_RESULTS.DESCRIPTION' | translate }}
        </palantir-text>
      } @else {
        <palantir-text type="description" size="xs">
          {{ 'TAB_WARRANTIES_EQUIPMENT.NO_RESULTS.NO_WARRANTY' | translate }}
        </palantir-text>
      }
    </div>

    @if (hasCreateWarrantyPermission) {
      <palantir-button (click)="openDialog()" theme="outline" layout="prefix" icon="add-outline">
        {{ 'TAB_WARRANTIES_MAINTENANCE.BUTTON.ADD' | translate }}</palantir-button
      >
    }
  </div>
}
